export const DISABLED_COLOR_INDEX = -1;
export const DEFAULT_COLOR_INDEX = 11;
export const DEFAULT_PATTERN_INDEX = 0;
export const DOWNSIZE_THRESHOLD_MBS = 0.5;
// Longest-edge cap when converting a HEIC photo to JPEG on canvas, so a 24MP iPhone photo
// doesn't get drawn at full resolution on mobile.
export const MAX_HEIC_CONVERSION_DIMENSION = 2048;

export enum Step {
  PHOTO = 'Photo',
  CARTOON = 'Avatar',
  PATTERN_COLOR = 'Pattern & Color',
}

export const STEPS = [Step.PHOTO, Step.CARTOON, Step.PATTERN_COLOR];
